/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsIcon16Light = forwardRef('DocsIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3.5A2.5 2.5 0 0 1 4.5 1h3.015a1.5 1.5 0 0 1 1.06.44l2.986 2.984A1.5 1.5 0 0 1 12 5.484V11.5A2.5 2.5 0 0 1 9.5 14h-5A2.5 2.5 0 0 1 2 11.5v-8ZM4.5 2A1.5 1.5 0 0 0 3 3.5v8A1.5 1.5 0 0 0 4.5 13h5a1.5 1.5 0 0 0 1.5-1.5V6H8.5A1.5 1.5 0 0 1 7 4.5V2H4.5Zm3.5.278L10.722 5H8.5a.5.5 0 0 1-.5-.5V2.278Z" }),
        React.createElement("path", { d: "M14 6.5a.5.5 0 0 0-1 0V12a3 3 0 0 1-3 3H5.5a.5.5 0 0 0 0 1H10a4 4 0 0 0 4-4V6.5Z" })));
});
